import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  input: {
    display: 'none',
  },
  image: {
    width: '100%'
  }
})